// extracted by mini-css-extract-plugin
module.exports = {"cartIcon":"style_cartIcon__1680m","checkOut":"style_checkOut__3HW2P","totalPrice":"style_totalPrice__2Recv"};